import { getAxiosInstance } from "../../../../api";

export const handleAddNote = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/admin/order/note/add`, body);

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
